import { fleekActions } from '../../fleek/actionTypes';

const initial = {
  showCartPopup: false,
  showWislistPopup: false,
  modalPopup: false,
  addedToCart: false,
  wishlistStatus: '',
  hideMinicart: '',
  isProductRemoved: false,
  addedToCartMembership: false,
  showRevampedCategoriesForAjiogram: false
};

export default function Popup(state = initial, action) {
  switch (action.type) {
    case 'SHOW_CART_POPUP':
      return {
        ...state,
        showCartPopup: action.showCartPopup,
        addedToCart: true
      };

    case 'SHOW_CART_MEMBERSHIP':
      return {
        ...state,
        addedToCartMembership: true
      };

    case 'SHOW_WISHLIST_POPUP':
      return {
        ...state,
        showWislistPopup: action.showWishlistPopup,
        wishlistStatus: action.wishlistStatus,
        isProductRemoved: action.isProductRemoved
      };

    case 'OPEN_MODAL':
      return {
        ...state,
        modalPopup: action.showModalPopup,
        product: action.product
      };

    case 'CLOSE_MODAL':
      return {
        ...state,
        modalPopup: action.closeModalPopup,
        product: null
      };

    case 'COLOR_SWATCH_POPUP':
      return {
        ...state,
        modalPopup: action.showModalPopup,
        product: action.product
      };

    case 'RESET_CART_ITEM':
      return {
        ...state,
        addedToCart: false
      };

    case 'HIDE_MINICART':
      return {
        ...state,
        showCartPopup: false,
        hideMinicart: true
      };

    case 'CLOSE_ALL_POPUP':
      return {
        ...state,
        showCartPopup: false,
        showWislistPopup: false
      };

    case fleekActions.SET_CATEGORIES_STATE:
      return {
        ...state,
        showRevampedCategoriesForAjiogram: action.payload.visible
      };

    default:
      return state;
  }
}
